import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useTheme } from '../../context/PermissionsContext/ThemeContext/ThemeContext';

export default function TeamFormAddImageSkeleton(props) {
  const { isModal } = props;
  const { theme } = useTheme();

  return (
    <Box
      style={{
        display: 'flex',
        width: '100%',
        justifyContent: isModal ? 'flex-start' : 'center',
      }}
    >
      <Box
        style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          // width: '100%',
          // height: 361,
          // borderRadius: 8,
          width: 240,
          height: 240,
          borderRadius: 2000,
          marginBottom: 24,
        }}
        sx={{
          backgroundColor: theme.primaryLight,
        }}
      >
        <CircularProgress style={{ color: theme.primary }}></CircularProgress>
      </Box>
    </Box>
  );
}
